import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppComponent } from '../app.component';
import { InfoFirmasComponent } from '../info-firmas/info-firmas.component';
import { Util } from '../utils/util';
import { DataService } from '../_services/data.service';
import { MatriculacionService } from '../_services/matriculacion.service';


@Component({
  selector: 'app-inicio-matriculacion',
  templateUrl: './inicio-matriculacion.component.html',
  styleUrls: ['./inicio-matriculacion.component.scss']
})
export class InicioMatriculacionComponent implements OnInit, OnDestroy {

  private archivos?: FileList;
  private archivoSeleccionado?: File;
  public mensajeError?: String;
  public pathPdf?: String;
  public fileInfos?: Observable<any>;
  public pdfData: any;
  public pdfB64: any;
  public md5?: String;
  private util: Util;
  public pdfConfirmado: Boolean;
  forInicioTramite!: FormGroup;
  formEnviado: Boolean;
  formEnviando: Boolean;
  error!:Boolean;
  public mostrarPdf?: Boolean;
  resultadoMatricula: any;
  errorString!:string;
  constructor(private formBuilder: FormBuilder, 
              private router: Router,
              private dataService: DataService,
              private matriculacionService: MatriculacionService, 
              public appComponent: AppComponent) {
    this.pathPdf = "";
    this.mensajeError = "";
    this.md5 = "";
    this.util = new Util();
    this.pdfConfirmado = false;
    this.formEnviado = false;
    this.formEnviando = false;
    this.mostrarPdf = false;
  }

  get formulario(): { [key: string]: AbstractControl } {
    return this.forInicioTramite.controls;
  }

  ngOnInit(): void {
    this.forInicioTramite = this.formBuilder.group(
      {
        idTipoDocumento: ['DNI', Validators.required],
        numeroDocumento: [
          null,
          Validators.compose(
            [
              Validators.required,
              Validators.pattern('^[0-9]{6,8}$')
            ])
        ],
        sexo: [null, Validators.required],
        archivo: [null, Validators.required]
      }
    );
  }

  ngOnDestroy() {
    this.dataService.datosMatricula = this.resultadoMatricula;
  }

  onSubmit() {
    this.formEnviado = true;
    if (this.forInicioTramite.valid) {
      if (this.pdfConfirmado) {
        this.enviarForm();
      }
    }
  }

  enviarForm() {
    this.formEnviando = true;
    this.error=false;
    let formObj = this.forInicioTramite.getRawValue();
    formObj.checksumArchivo = this.md5;
    formObj.archivo = this.pdfData;
    formObj.idUsuario = this.appComponent.usuarioLogueado?.idUsuario;
   
    this.resultadoMatricula=null;
    this.matriculacionService.postMatricula(formObj).subscribe(result => {
      this.resultadoMatricula = result;
      this.router.navigate(["/info-firmas"]);
    }, (error) => {
      this.errorString=error;
      this.error=true;
      this.formEnviando=false;
    });

  }

  onFileSelect(event: any): void {
    this.archivos = event.target.files;
    if (this.archivos != null) {
      this.pdfConfirmado = true;
      this.archivoSeleccionado = this.archivos[0];
      this.util.incrementalMD5(this.archivoSeleccionado).then(
        md5 => {
          this.md5 = md5;
          console.log("MD5 Archivo:", this.md5);
        }
      );
      this.pathPdf = this.archivoSeleccionado.name;
      this.util.getBase64(this.archivoSeleccionado).then(
        (data: any) => {
          this.pdfB64 = data;
          this.pdfData = data.substr(data.indexOf(',') + 1);
          this.mostrarPdf = true;
        }
      );
    }
  }

}
